import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    movement: [
      { label: 'About Us', href: '/the-movement' },
      { label: 'Festival Guide', href: '/festival-guide' },
      { label: 'Global Impact', href: '/global-impact' },
      { label: 'Research', href: '/research-evidence' },
    ],
    engage: [
      { label: 'Join Us', href: '/join-the-movement' },
      { label: 'Community Stories', href: '/community-stories' },
      { label: 'Partner Network', href: '/partner-network' },
      { label: 'Resources Hub', href: '/resources-hub' },
    ],
    support: [
      { label: 'Humanitarian Action', href: '/humanitarian-action' },
      { label: 'Global Calendar', href: '/global-calendar' },
      { label: 'Media Center', href: '/media-center' },
    ],
  };

  const socialLinks = [
    { name: 'Facebook', icon: 'ShareIcon', href: 'https://www.facebook.com/signoenemy' },
    { name: 'Twitter', icon: 'ChatBubbleLeftRightIcon', href: '#' },
    { name: 'Instagram', icon: 'PhotoIcon', href: '#' },
    { name: 'LinkedIn', icon: 'BriefcaseIcon', href: '#' },
    { name: 'YouTube', icon: 'VideoCameraIcon', href: 'https://www.youtube.com/@signoenemy' },
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <Link href="/homepage" className="flex items-center space-x-3 mb-6">
              <AppImage
                src="/assets/images/LOGO-SIGLINE_PNG-1769633021018.png"
                alt="SIG Day Logo - The Global No Enemy Festival"
                width={40}
                height={40}
                className="rounded-md"
              />
              <div>
                <span className="text-lg font-headline font-bold text-primary block">SIG Day</span>
                <span className="text-xs text-muted-foreground">The Global No Enemy Festival</span>
              </div>
            </Link>
            <p className="text-sm text-muted-foreground font-body leading-relaxed mb-4">
              Transforming conflict through forgiveness, one heart at a time.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-10 h-10 rounded-full bg-muted flex items-center justify-center text-foreground hover:bg-primary hover:text-primary-foreground transition-colors duration-300"
                  aria-label={social.name}
                >
                  <Icon name={social.icon as any} size={20} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-cta font-bold text-foreground uppercase mb-4">The Movement</h3>
            <ul className="space-y-2">
              {footerLinks.movement.map((link) => (
                <li key={link.href}>
                  <Link href={link.href} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 font-body">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-cta font-bold text-foreground uppercase mb-4">Get Involved</h3>
            <ul className="space-y-2">
              {footerLinks.engage.map((link) => (
                <li key={link.href}>
                  <Link href={link.href} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 font-body">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-cta font-bold text-foreground uppercase mb-4">Support</h3>
            <ul className="space-y-2">
              {footerLinks.support.map((link) => (
                <li key={link.href}>
                  <Link href={link.href} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 font-body">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground font-body">
              &copy; {currentYear} SIG Day No Enemy Peace Movement. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 font-body">
                Privacy Policy
              </Link>
              <Link href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 font-body">
                Terms of Service
              </Link>
              <Link href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 font-body">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;